export default "__VITE_ASSET__BEVlq_7z__"